import { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Clients } from "./components/clients";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import { Footer } from './components/footer'
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features {...landingPageData.Features} />
      <About {...landingPageData.About} />
      <Services {...landingPageData.Services} />
      <Clients {...landingPageData.Clients} />
      <Testimonials data={landingPageData.Testimonials} />
      <Team {...landingPageData.Team} />
      <Contact data={landingPageData.Contact} />
      <Footer data={landingPageData.Contact} />
    </div>
  );
};

export default App;
